"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var StringOrDateParser_1 = require("../../core/model/data-dictionary/parsers/StringOrDateParser");

var KpiDataStructureEnum;

(function (KpiDataStructureEnum) {
  KpiDataStructureEnum["PromoSalesReal"] = "PromoSalesReal";
  KpiDataStructureEnum["VolumeReal"] = "PromoSalesReal";
})(KpiDataStructureEnum || (KpiDataStructureEnum = {}));

var NewSalesDashboardReportRow =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(NewSalesDashboardReportRow, _DomainObject_1$Domai);

  function NewSalesDashboardReportRow( // Meta data
  id, reportId, // Tree and entity data
  level, entity, entityId, isGroup, title, titleData) {
    var _this;

    var regularKpiValues = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
    var regularKpiValuesDeltas = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
    var leafletKpiValues = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
    var leafletKpiValuesDeltas = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
    var nonLeafletKpiValues = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
    var nonLeafletKpiValuesDeltas = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
    var totalKpiValues = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : null;
    var totalKpiValuesDeltas = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : null;
    var regNonLeafletKpiValues = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : null;
    var regNonLeafletKpiValuesDeltas = arguments.length > 17 && arguments[17] !== undefined ? arguments[17] : null;

    _classCallCheck(this, NewSalesDashboardReportRow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NewSalesDashboardReportRow).call(this));
    _this.id = id;
    _this.reportId = reportId;
    _this.level = level;
    _this.entity = entity;
    _this.entityId = entityId;
    _this.isGroup = isGroup;
    _this.title = title;
    _this.titleData = titleData;
    _this.regularKpiValues = regularKpiValues;
    _this.regularKpiValuesDeltas = regularKpiValuesDeltas;
    _this.leafletKpiValues = leafletKpiValues;
    _this.leafletKpiValuesDeltas = leafletKpiValuesDeltas;
    _this.nonLeafletKpiValues = nonLeafletKpiValues;
    _this.nonLeafletKpiValuesDeltas = nonLeafletKpiValuesDeltas;
    _this.totalKpiValues = totalKpiValues;
    _this.totalKpiValuesDeltas = totalKpiValuesDeltas;
    _this.regNonLeafletKpiValues = regNonLeafletKpiValues;
    _this.regNonLeafletKpiValuesDeltas = regNonLeafletKpiValuesDeltas;
    return _this;
  }

  _createClass(NewSalesDashboardReportRow, [{
    key: "hasEmptyKpis",
    value: function hasEmptyKpis(promotionTypes) {
      var _this2 = this;

      var isEmpty = true;
      promotionTypes.forEach(function (promotionType) {
        if (!_this2.hasEmptyKpiValues(_this2[promotionType])) {
          isEmpty = false;
        }

        if (!_this2.hasEmptyKpiValues(_this2["".concat(promotionType, "Deltas")])) {
          isEmpty = false;
        }
      });
      return isEmpty;
    }
  }, {
    key: "hasEmptyKpiValues",
    value: function hasEmptyKpiValues(kpis) {
      if (kpis === null) {
        return true;
      }

      var empty = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = kpis.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              kpi = _step$value[1];

          if (KpiDataStructureEnum.PromoSalesReal === key && kpi.equals(0)) {
            return true;
          } else if (kpi.abs().gt(0)) {
            empty = false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return empty;
    }
  }]);

  return NewSalesDashboardReportRow;
}(DomainObject_1.DomainObject);

exports.NewSalesDashboardReportRow = NewSalesDashboardReportRow;

NewSalesDashboardReportRow.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NewSalesDashboardReportRow.name);
  return {
    id: builder.str('id'),
    reportId: builder.str('reportId'),
    //
    level: builder.num('level'),
    entity: builder.opt(builder.str('entity')),
    entityId: builder.opt(builder.str('entityId')),
    isGroup: builder.bool('isGroup'),
    title: builder.opt(builder.str('title')),
    titleData: builder.opt(builder.custom('titleData', new StringOrDateParser_1.StringOrDateParser())),
    //
    regularKpiValues: builder.opt(builder.smap(builder.bigNum('regularKpiValues'))),
    regularKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('regularKpiValuesDeltas'))),
    leafletKpiValues: builder.opt(builder.smap(builder.bigNum('leafletKpiValues'))),
    leafletKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('leafletKpiValuesDeltas'))),
    nonLeafletKpiValues: builder.opt(builder.smap(builder.bigNum('nonLeafletKpiValues'))),
    nonLeafletKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('nonLeafletKpiValuesDeltas'))),
    totalKpiValues: builder.opt(builder.smap(builder.bigNum('totalKpiValues'))),
    totalKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('totalKpiValuesDeltas'))),
    regNonLeafletKpiValues: builder.opt(builder.smap(builder.bigNum('regNonLeafletKpiValues'))),
    regNonLeafletKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('regNonLeafletKpiValuesDeltas')))
  };
}();